import { useState, useContext, useEffect } from 'react'
import { makeStyles, Tabs, Tab, Container } from '@material-ui/core'
import { Context } from '../../context'

import DomesticForm from './DomesticForm'
import InterForm from './InterForm'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'transparent',
  },
  tabs: {
    backgroundColor: 'white',
    width: 'fit-content',
    padding: 0,
    borderRadius: 8,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottom: '1px solid #E0E0E0',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: 0,
    },
  },
  card: {
    backgroundColor: 'white',
    width: '100%',
    padding: theme.spacing(2),
    borderRadius: 8,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    [theme.breakpoints.down('sm')]: {
      borderTopRightRadius: 0,
    },
  },
  tabRoot: {
    padding: `${theme.spacing(1.2)}px ${theme.spacing(1)}px`,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
    width: 180,
  },
  tabWrapper: {
    flexDirection: 'row',
    '& img': {
      marginRight: 10,
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  bar: {
    width: '100vw',
    padding: `${theme.spacing(1)}px 0`,
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: theme.palette.primary.main,
    zIndex: theme.zIndex.appBar + 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  colorWhite: {
    color: 'white',
  },
}))

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  )
}

const CheckpriceForm = ({
  submitMode = 'redirect', // 'fetch' is to fetch and shows data in /checkprice, 'redirect' is to redirect to /checkprice used in other pages.
  setCheckpriceResultList, // this will exist if it is in 'fetch' mode
  setResultStatus, // this will exist if it is in 'fetch' mode
  setLastFetchBody,
  required = true,
}) => {
  const [activeTab, setActiveTab] = useState(0)
  const [displayMode, setDisplayMode] = useState('full')
  const { state, dispatch } = useContext(Context)

  const classes = useStyles()
  const { t } = useTranslation('checkprice')
  const Router = useRouter()

  const tabs = [
    [t('domestic-delivery'), 'checkprice-icon-truck.svg'],
    // v for the future version
    // [<>ส่งด่วน 1-2 ชม.{!isMobile && '(กทม-ปริม)'}</>, 'checkprice-icon-motorcycle.svg'],
    [t('inter-delivery'), 'checkprice-icon-plane.svg'],
  ]

  useEffect(() => {
    if (!Router.isReady) return
    if (submitMode === 'fetch' && Router.query.typeid === 'inter') {
      setActiveTab(1)
    }
  }, [Router.isReady])

  const renderCheckpriceFormFull = () => (
    <div className={classes.root}>
      <div className={classes.tabs}>
        <Tabs
          value={activeTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, newValue) => setActiveTab(newValue)}
          variant="fullWidth"
        >
          {tabs.map(([label, iconName]) => (
            <Tab
              label={label}
              icon={<img src={`/static/img/home/${iconName}`} alt={label} />}
              classes={{
                root: classes.tabRoot,
                wrapper: classes.tabWrapper,
                selected: classes.activeTab,
              }}
              key={label}
            />
          ))}
        </Tabs>
      </div>
      <div className={classes.card}>
        <TabPanel value={activeTab} index={0}>
          <DomesticForm
            submitMode={submitMode}
            setCheckpriceResultList={setCheckpriceResultList}
            setResultStatus={setResultStatus}
            setLastFetchBody={setLastFetchBody}
            key="domesticForm"
            required={required}
          />
        </TabPanel>
        {/* <TabPanel value={activeTab} index={1}>
            <ExpressForm />
          </TabPanel> */}
        <TabPanel value={activeTab} index={1}>
          <InterForm
            submitMode={submitMode}
            setCheckpriceResultList={setCheckpriceResultList}
            setResultStatus={setResultStatus}
            key="interForm"
            required={required}
          />
        </TabPanel>
      </div>
    </div>
  )

  // for the future version!
  // const renderCheckpriceFormBar = () => (
  //   <div className={classes.bar}>
  //     <Container>
  //       <Tabs
  //         value={activeTab}
  //         onChange={(e, newValue) => setActiveTab(newValue)}
  //         indicatorColor="secondary"
  //         textColor="secondary"
  //       >
  //         {tabs.map(([label, _]) => (
  //           <Tab
  //             label={label}
  //             key={label}
  //             classes={{ root: classes.colorWhite }}
  //           />
  //         ))}
  //       </Tabs>
  //       <TabPanel value={activeTab} index={0}>
  //         <DomesticForm
  //           submitMode={submitMode}
  //           setCheckpriceResultList={setCheckpriceResultList}
  //           setResultStatus={setResultStatus}
  //           displayMode="bar"
  //           key="domesticForm"
  //           isActive={activeTab === 0}
  //         />
  //       </TabPanel>
  //       <TabPanel value={activeTab} index={1}>
  //         <InterForm
  //           submitMode={submitMode}
  //           setCheckpriceResultList={setCheckpriceResultList}
  //           setResultStatus={setResultStatus}
  //           displayMode="bar"
  //           key="interForm"
  //           isActive={activeTab === 1}
  //         />
  //       </TabPanel>
  //     </Container>
  //   </div>
  // )

  return (
    <>
      {displayMode === 'full'
        ? renderCheckpriceFormFull()
        : renderCheckpriceFormBar()}
    </>
  )
}

export default CheckpriceForm
